import _ from 'lodash';
import {applyLagTempRhShift, lagHoursFromVariables, lagSourceRow} from '../../lag_weather_utils';
import {emptyGraphMap, round} from '../../point_utils';
import {addDays, lastMidnightDate} from '../../time_utils';

export const PREFIX_T = 'HP_T_SFC';
export const PREFIX_RH = 'HP_RH_SFC';
export const PREFIX_WIND_DIR = 'HP_Wind_Dir_SFC';
export const PREFIX_WIND_MAG_KPH = 'HP_WindMag_SFC';
export const PREFIX_DF = 'HP_DF_SFC';
export const PREFIX_CURING = 'HP_Curing_SFC';
export const PREFIX_KBDI = 'HP_KBDI_SFC';

export const applyModifications = (wd, mods) => {
  if (mods) {
    return {
      ...wd,
      ...mods
    };
  } else {
    return wd;
  }
};

const _toGraphData = (table_data, keys) => {
  const graph_data = {
    name: table_data.name,
    sortIndex: table_data.sortIndex
  };

  keys.forEach((k) => {
    if (typeof table_data[`${k}_modified`] !== 'undefined') {
      graph_data[k] = table_data[`${k}_modified`];
    } else {
      graph_data[k] = table_data[k];
    }
  });

  return graph_data;
};

export const calculateTableData = (meta_data,
                                   include_history,
                                   short_future,
                                   weather_data,
                                   variables,
                                   modifications) => {
  const now = new Date();
  const start_time = include_history ? null : new Date(lastMidnightDate(now)).getTime();
  const end_time = short_future ? new Date(addDays(lastMidnightDate(now), 2)).getTime() : null;

  const lagHours = lagHoursFromVariables(variables);
  const effectiveWeather = applyLagTempRhShift(weather_data, modifications, lagHours);
  const baselineLaggedWeather = lagHours ?
    applyLagTempRhShift(weather_data, {}, lagHours) :
    weather_data;

  const new_table_data = {};
  _.values(weather_data).forEach(wd => {
    if ((!start_time || wd.sortIndex >= start_time) && (!end_time || wd.sortIndex < end_time)) {
      const baseWd = effectiveWeather[wd.name] || wd;
      const baselineWd = baselineLaggedWeather[wd.name] || wd;
      const row = { name: wd.name, sortIndex: wd.sortIndex };
      meta_data.forEach(v => {
        row[v.key] = round(v.calc(baseWd, variables), v.decPlaces);
      });

      if (lagHours) {
        const source = lagSourceRow(weather_data, wd, lagHours);
        const sourceMods = source && modifications[source.name];
        const hasTrMods = sourceMods &&
          (typeof sourceMods[PREFIX_T] !== 'undefined' || typeof sourceMods[PREFIX_RH] !== 'undefined');
        if (hasTrMods) {
          meta_data.forEach(v => {
            const unmodifiedValue = round(v.calc(baselineWd, variables), v.decPlaces);
            if (unmodifiedValue !== row[v.key]) {
              row[`${v.key}_modified`] = row[v.key];
            }
          });
        }
      } else {
        const mods = modifications[wd.name];
        if (mods) {
          const modified_wd = applyModifications(baseWd, mods);
          meta_data.forEach(v => {
            const unmodifiedValue = row[v.key];
            const modifiedValue = round(v.calc(modified_wd, variables), v.decPlaces);
            if (unmodifiedValue !== modifiedValue) {
              row[`${v.key}_modified`] = modifiedValue;
            }
          });
        }
      }

      new_table_data[wd.name] = row;
    }
  });
  return new_table_data;
};

export const convertToGraphData = (meta_data, new_table_data) => {
  // For each graph, create an array of value keys
  const datakeys = {};
  meta_data.forEach((g) => {
    datakeys[g.id] = g.series.map(s => s.dataKey);
  });

  const graph_data = emptyGraphMap(meta_data);
  _.values(new_table_data).forEach((td) => {
    meta_data.forEach((graph_config) => {
      const keys = datakeys[graph_config.id];
      graph_data[graph_config.id].push(_toGraphData(td, keys));
    });
  });

  // Sort the arrays
  meta_data.forEach((graph_config) => {
    graph_data[graph_config.id].sort((r1, r2) => r1.sortIndex - r2.sortIndex);
  });

  return graph_data;
};

export const tableMetaData = (meta_data, data_set) => {
  return meta_data.map(v => {
    return {
      key: v.key,
      displayName: v.displayName,
      decPlaces: v.decPlaces || 0,
      colors: v.colors,
      formatFn: v.formatFn,
      cellGraph: v.cellGraph,
      nonFinal: v.nonFinal,
      arrow: v.arrow,
      data_set
    };
  });
};



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/shared/behaviour_models_utils.js